var variantSelector = document.getElementsByClassName('select__select');
if (variantSelector.length > 0){
  variantSelected()
}

function variantSelected(){
  
  
  var variantSelector = document.getElementsByClassName('select__select');
  if (variantSelector.length > 0){
    var selectedVariant = variantSelector[0].options[variantSelector[0].selectedIndex];
    console.log(selectedVariant.dataset)
    var selectedVariantIntroPeriod = selectedVariant.dataset.variantIntroPeriod;
    var stockStatus = selectedVariant.dataset.variantStockStatus;
    var inputVoltage = selectedVariant.dataset.variantInputVoltage;
    var cct = selectedVariant.dataset.variantCct;
    var deliveredLumen = selectedVariant.dataset.variantDeliveredLumen;
    var glassDetails = selectedVariant.dataset.variantGlassDetails;
    var shadeDetails = selectedVariant.dataset.variantShadeDetails;
    var diffuserDetails = selectedVariant.dataset.variantDiffuserDetails;
    var countryOfOrigin = selectedVariant.dataset.variantCountryOfOrigin;
    var energyStar = selectedVariant.dataset.variantEnergyStar;
    var darkSkyCompliance = selectedVariant.dataset.variantDarkSkyCompliance;
    var safetyCompliance = selectedVariant.dataset.variantSafetyCompliance;
    var paintFinishCode = selectedVariant.dataset.variantPaintFinishCode;
    var paintFinishType = selectedVariant.dataset.variantPaintFinishType;
    var fixtureMaterial = selectedVariant.dataset.variantFixtureMaterial;
    var wireStyle = selectedVariant.dataset.variantWireStyle;
    var fixtureDimensions = selectedVariant.dataset.variantFixtureDimensions;
    var canopyDimensions = selectedVariant.dataset.variantCanopyDimensions;
    var baseDimensions = selectedVariant.dataset.variantBaseDimensions;
    var shadeDimensions = selectedVariant.dataset.variantShadeDimensions;
    if (stockStatus.length > 0){
      var stockStatusItems = stockStatus.split('|')
      var stockStatusItemsHTML = ""
      stockStatusItems.forEach((statusItem)=>{
        if (statusItem.includes('Low')){
          stockStatusItemsHTML += "<svg width='15' height='15' aria-hidden='true' class='low-stock-badge'><circle cx='7.5' cy='7.5' r='7.5' fill='rgb(238,148,65, 0.3)'/><circle cx='7.5' cy='7.5' r='5' stroke='rgb(255, 255, 255)' stroke-width='1' fill='rgb(238,148,65)'/></svg> "+statusItem
          stockStatusItemsHTML += "<br>"
        }else if (statusItem.includes('Out')){
          if (selectedVariantIntroPeriod.includes('2025')){
            // Get last element of string elements to determine which location is coming soon
            var statusParts = statusItem.split(" ")
            var location = ""
            if (statusParts.length > 0){
              location = statusParts[statusParts.length-1];
            }
            stockStatusItemsHTML += "<svg width='15' height='15' aria-hidden='true' class='out-stock-badge'><circle cx='7.5' cy='7.5' r='7.5' fill='rgb(200,200,200, 0.3)'/><circle cx='7.5' cy='7.5' r='5' stroke='rgb(255, 255, 255)' stroke-width='1' fill='rgb(200,200,200)'/></svg> Coming Soon to "+location
            stockStatusItemsHTML += "<br>"
          }else{
            stockStatusItemsHTML += "<svg width='15' height='15' aria-hidden='true' class='out-stock-badge'><circle cx='7.5' cy='7.5' r='7.5' fill='rgb(200,200,200, 0.3)'/><circle cx='7.5' cy='7.5' r='5' stroke='rgb(255, 255, 255)' stroke-width='1' fill='rgb(200,200,200)'/></svg> "+statusItem
            stockStatusItemsHTML += "<br>"
          }
        }else if (statusItem.includes('In')){
          stockStatusItemsHTML += "<svg width='15' height='15' aria-hidden='true' class='in-stock-badge'><circle cx='7.5' cy='7.5' r='7.5' fill='rgb(62,214,96, 0.3)'/><circle cx='7.5' cy='7.5' r='5' stroke='rgb(255, 255, 255)' stroke-width='1' fill='rgb(62,214,96)'/></svg> "+statusItem
          stockStatusItemsHTML += "<br>"
        }
        else{
            stockStatusItemsHTML += "<svg width='15' height='15' aria-hidden='true' class='out-stock-badge'><circle cx='7.5' cy='7.5' r='7.5' fill='rgb(200,200,200, 0.3)'/><circle cx='7.5' cy='7.5' r='5' stroke='rgb(255, 255, 255)' stroke-width='1' fill='rgb(200,200,200)'/></svg> "+statusItem
            stockStatusItemsHTML += "<br>"
        }
      })
      var stockStatusHTML = "<span class='inventory_status_item'>"+stockStatusItemsHTML+"</span>"
      document.getElementsByClassName('product_page_inventory_status')[0].innerHTML = stockStatusHTML;
    }


    // Defining Variant HTML section under specifications
    var variantSpecDataHTML = ""
    variantSpecDataHTML += "<table class='kzg_spec_table'><thead></thead><tbody>"

    const variant_spec_data_elements = [
      { title: 'Input Voltage', value: inputVoltage },
      { title: 'Color Temperature', value: cct },
      { title: 'Delivered Lumen', value: deliveredLumen },
      { title: 'Glass Details', value: glassDetails },
      { title: 'Shade Details', value: shadeDetails },
      { title: 'Diffuser Details', value: diffuserDetails },
      { title: 'Country of Origin', value: countryOfOrigin },
      { title: 'Energy Star', value: energyStar },
      { title: 'DarkSky Compliant', value: darkSkyCompliance },
      { title: 'Compliance', value: safetyCompliance },
      { title: 'Paint Finish', value: paintFinishCode },
      { title: 'Finish Type', value: paintFinishType },
      { title: 'Material', value: fixtureMaterial },
      { title: 'Wire Style', value: wireStyle },
      { title: 'Fixture Dimensions', value: fixtureDimensions },
      { title: 'Canopy Dimensions', value: canopyDimensions },
      { title: 'Base Dimensions', value: baseDimensions },
      { title: 'Lamp Shade Dimensions', value: shadeDimensions }
    ];

    for (let i = 0; i < variant_spec_data_elements.length; i++) {
      if(variant_spec_data_elements[i].value != ""){
        variantSpecDataHTML += "<tr><td class='kzg_spec_table_label'>"+variant_spec_data_elements[i].title+"</td>"
        variantSpecDataHTML += "<td class='kzg_spec_table_value'>"+variant_spec_data_elements[i].value+"</td></tr>"
      }
    }    
    variantSpecDataHTML += "</tbody></table>"
    document.getElementsByClassName('variant_spec_data')[0].innerHTML = variantSpecDataHTML;
    
  }
}

